module.exports = __webpack_public_path__ + "img/product-default.8a8cb076.jpg";